import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../../component/navbar";
import building from "../../assets/images/building.webp";
import institute from "../../assets/images/institute1.png";
import bus from "../../assets/images/bus.png";
import bus1 from "../../assets/images/bus1.png";
import car from "../../assets/images/car.png";
import car1 from "../../assets/images/car1.webp";
import checked from "../../assets/images/checked.png";
import verified from "../../assets/images/verified.png";
import trafficLight from "../../assets/images/trafficLight.png";
import calendar from "../../assets/images/calendar.png";
import aboutImg from "../../assets/images/aboutImg.svg";

import liaquatNational from "../../assets/images/liaquatNational.png";
import Sohailuniversity from "../../assets/images/Sohailuniversity.webp";
import jsmu from "../../assets/images/jmdc.png";
import pafKiet from "../../assets/images/pafKiet.jpg";
import alHuda from "../../assets/images/alHuda.png";
import sTiles from "../../assets/images/sTiles.png";
import { Footer } from "../../component/footer";
import animate from "../../assets/js/animate";
import { ContactSection } from "./contact";

export const Home = () => {
  useEffect(() => {
    animate();
  }, []);
  return (
    <div className="homePage">
      <header className="header homePage" id="header">
        <Navbar />
        <div className="bus">
          <img src={bus1} alt="bus" />
        </div>
        <div className="car">
          <img src={car1} alt="bus" />
        </div>
        <div className="headerImgMain">
          <img src={building} alt="building" />
          <div className="overlay"></div>
        </div>
        <section className="headerSection">
          <div className="container">
            <div className="animatable slideInUp animationDelay300">
              <h1 className="main-title">
                Karachi Trusted Transport Partner <br /> for Offices &
                Institutes
              </h1>
            </div>
            <div className="animatable slideInUp animationDelay500">
              <p className="para">
                Reliable daily corporate transport, secure rentals, and custom
                fleet contracts built for your convenience.
              </p>
            </div>
            <div className="mt-5 headerBtn animatable slideInUp animationDelay500">
              {/* <Link className="getStatedBtn" to="/contact">
                Get a Demo
              </Link> */}
              {/* <a href="tel:+923122708809" className="getStatedBtn mb-3">
                Get a Demo
              </a> */}
              <Link to="/booking" className="getStatedBtn">
                Book Now
              </Link>
              {/* <Link to="/booking" className="getStatedBtn" style={{ background: "#fff", color: "#1a1f5e" }}>
                Book Now
              </Link> */}
              {/* <button className="buyCoinBtn ml-3">Whitepaper</button> */}
            </div>
          </div>
        </section>
      </header>

      <section className="serviceSec" id="services">
        <div className="container">
          <h1 className="homeHeading">Services we offer</h1>
          <div className="row">
            <div className="col-md-4">
              <div className="sCard animatable slideInUp ">
                <div className="icoM">
                  <img src={institute} alt="" />
                </div>
                <div className="title">Contract Transport</div>
                <div className="desc">
                  Long-Term daily transport services for offices and
                  universities
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="sCard animatable slideInUp animationDelay200">
                <div className="icoM">
                  <img src={bus} alt="" />
                </div>
                <div className="title">Bus Rental</div>
                <div className="desc">
                  Rent clean, air conditioned, buses with driver
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="sCard animatable slideInUp animationDelay400">
                <div className="icoM">
                  <img src={car} alt="" />
                </div>
                <div className="title">Car Contract</div>
                <div className="desc">
                  Cars available for executive office pickups, and events
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="whySec">
        <div className="container">
          <h1 className="homeHeading">Why choose us?</h1>
          <div className="row">
            <div className="col-md-6">
              <div className="cRow animatable slideInUp ">
                <div className="ico">
                  <img src={checked} alt="" />
                </div>
                <div className="title">
                  Trusted by Karachi's top institutions
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="cRow animatable slideInUp animationDelay200">
                <div className="ico">
                  <img src={verified} alt="" />
                </div>
                <div className="title">On time guarantee & 24/7 support </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="cRow animatable slideInUp animationDelay300">
                <div className="ico">
                  <img src={trafficLight} alt="" />
                </div>
                <div className="title">
                  GPS-Enabled vehicles & professional drivers
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="cRow animatable slideInUp animationDelay400">
                <div className="ico">
                  <img src={calendar} alt="" />
                </div>
                <div className="title">
                  Custom Schedules based on your needs
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="wboutSec" id="about">
        <div className="container">
          <div className="row ai-center">
            <div className="col-lg-6">
              <div className="imgDiv animatable zoomIn animationDelay100">
                <img src={aboutImg} alt="" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="content">
                <h3 className="title animatable slideInUp">Who We Are</h3>
                <div className="desc animatable slideInUp animationDelay300">
                  We're a Karachi-based transport company offering daily
                  contract services to offices and universities with a modern
                  fleet, professional drivers, and punctual operations. We're
                  committed to providing safe and comfortable travel across the
                  city.{" "}
                </div>
                <div className="established animatable slideInUp animationDelay400">
                  <div className="icon">
                    <img src={calendar} alt="Established" />
                  </div>
                  <div>
                    <div className="name">Established</div>
                    <div className="value">2000</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ourClintSec">
        <div className="container">
          <h2 className="heading">
            Trusted by leading institutions & businesses in Karachi
          </h2>
          <div className="logoRow">
            <div className="logo animatable slideInUp ">
              <img src={liaquatNational} alt="Liaquat National" />
            </div>
            <div className="logo animatable slideInUp animationDelay100">
              <img src={Sohailuniversity} alt="Sohail University" />
            </div>
            <div className="logo animatable slideInUp animationDelay200">
              <img src={jsmu} alt="jsmu" />
            </div>
            <div className="logo animatable slideInUp animationDelay300">
              <img src={pafKiet} alt="pafKiet" />
            </div>
            <div className="logo animatable slideInUp animationDelay400">
              <img src={alHuda} alt="alHuda" />
            </div>
            {/* <div className="logo animatable slideInUp animationDelay500">
              <img src={sTiles} alt="sTiles" />
            </div> */}
          </div>
        </div>
      </section>
      <ContactSection />

      <Footer />
    </div>
  );
};
